module.exports = __webpack_public_path__ + "img/abpay-visa.6bcf49c.png";